export const pcam = [
  {
    "titulo_item_nombre": "",
    "archivos": [
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "1. Anexo Partidas Autorizadas 2021 - Actualización al 21-abril-2021",
        "file_item_url": "../../../contenido/transparencia/convenios/1. Anexo Partidas Autorizadas 2021 - Actualizacion al 21-abril-2021.pdf"
      },
      {
        "extencion":"archivo-pdf",
        "file_item_nombre": "2. Anexo Partidas Autorizadas 2021 - Actualización al 15-octubre-2012",
        "file_item_url": "../../../contenido/transparencia/convenios/2. Anexo Partidas Autorizadas 2021 - Actualizacion al 15-octubre-2021.pdf"
      }
    ]
  }
  
  
]